import {
  action,
  computed,
  makeObservable,
  observable,
  onBecomeObserved,
} from "mobx"

import { catchErrors, merchantApi } from "@src/shared/api"
import { loading } from "@src/shared/classes/utils/loading"
import { buildChartData } from "@src/widgets/merchantStats/constants"
export const mockDay = [
  {
    completed_count: 120,
    diff_periods: "5",
    period: "day",
    periods: {
      "12": {
        "00": "5",
        "01": "3",
        "02": "2",
        "03": "1",
        "04": "0",
        "05": "0",
        "06": "1",
        "07": "2",
        "08": "5",
        "09": "8",
        "10": "10",
        "11": "12",
        "12": "15",
        "13": "18",
        "14": "20",
        "15": "22",
        "16": "25",
        "17": "28",
        "18": "30",
        "19": "32",
        "20": "30",
        "21": "25",
        "22": "20",
        "23": "15",
      },
    },
    success_rate: "95",
    type: "payin",
  },
  {
    completed_count: 90,
    diff_periods: "-2",
    period: "day",
    periods: {
      "12": {
        "00": "4",
        "01": "2",
        "02": "1",
        "03": "1",
        "04": "0",
        "05": "0",
        "06": "1",
        "07": "1",
        "08": "4",
        "09": "6",
        "10": "8",
        "11": "10",
        "12": "12",
        "13": "15",
        "14": "18",
        "15": "20",
        "16": "22",
        "17": "25",
        "18": "28",
        "19": "30",
        "20": "28",
        "21": "23",
        "22": "18",
        "23": "12",
      },
    },
    success_rate: "93",
    type: "on_ramp",
  },
]

export const mockMonth = [
  {
    completed_count: 320,
    diff_periods: "8",
    period: "month",
    periods: {
      "01": {
        "01": "10",
        "02": "12",
        "03": "15",
        "04": "18",
        "05": "20",
        "06": "22",
        "07": "25",
        "08": "28",
        "09": "30",
        "10": "32",
        "11": "35",
        "12": "38",
        "13": "40",
        "14": "42",
        "15": "45",
        "16": "48",
        "17": "50",
        "18": "52",
        "19": "55",
        "20": "58",
        "21": "60",
        "22": "62",
        "23": "65",
        "24": "68",
        "25": "70",
        "26": "72",
        "27": "75",
        "28": "78",
        "29": "80",
        "30": "82",
        "31": "85",
      },
    },
    success_rate: "97",
    type: "payin",
  },
  {
    completed_count: 200,
    diff_periods: "-3",
    period: "month",
    periods: {
      "01": {
        "01": "8",
        "02": "10",
        "03": "12",
        "04": "15",
        "05": "18",
        "06": "20",
        "07": "22",
        "08": "25",
        "09": "28",
        "10": "30",
        "11": "32",
        "12": "35",
        "13": "38",
        "14": "40",
        "15": "42",
        "16": "45",
        "17": "48",
        "18": "50",
        "19": "52",
        "20": "55",
        "21": "58",
        "22": "60",
        "23": "62",
        "24": "65",
        "25": "68",
        "26": "70",
        "27": "72",
        "28": "75",
        "29": "78",
        "30": "80",
        "31": "82",
      },
    },
    success_rate: "95",
    type: "off_ramp",
  },
]

const mock = [
  {
    completed_count: 420,
    diff_periods: "12",
    period: "week",
    periods: {
      current_week: {
        "01": "45",
        "02": "60",
        "03": "55",
        "04": "70",
        "05": "80",
        "06": "65",
        "07": "45",
      },
      last_week: {
        "01": "30",
        "02": "40",
        "03": "42",
        "04": "50",
        "05": "55",
        "06": "48",
        "07": "35",
      },
    },
    success_rate: "98",
    type: "on_ramp",
  },
  {
    completed_count: 310,
    diff_periods: "-5",
    period: "week",
    periods: {
      current_week: {
        "01": "35",
        "02": "42",
        "03": "38",
        "04": "46",
        "05": "50",
        "06": "44",
        "07": "30",
      },
      last_week: {
        "01": "40",
        "02": "45",
        "03": "43",
        "04": "48",
        "05": "55",
        "06": "50",
        "07": "38",
      },
    },
    success_rate: "96",
    type: "off_ramp",
  },
  {
    completed_count: 64,
    diff_periods: "3",
    period: "week",
    periods: {
      current_week: {
        "01": "5",
        "02": "8",
        "03": "6",
        "04": "10",
        "05": "12",
        "06": "14",
        "07": "9",
      },
      last_week: {
        "01": "6",
        "02": "7",
        "03": "8",
        "04": "9",
        "05": "10",
        "06": "11",
        "07": "8",
      },
    },
    success_rate: "92",
    type: "refund",
  },
  {
    completed_count: 780,
    diff_periods: "18",
    period: "week",
    periods: {
      current_week: {
        "01": "90",
        "02": "110",
        "03": "105",
        "04": "130",
        "05": "150",
        "06": "135",
        "07": "120",
      },
      last_week: {
        "01": "70",
        "02": "85",
        "03": "90",
        "04": "100",
        "05": "110",
        "06": "105",
        "07": "95",
      },
    },
    success_rate: "99",
    type: "payin",
  },
  {
    completed_count: 540,
    diff_periods: "8",
    period: "week",
    periods: {
      current_week: {
        "01": "65",
        "02": "75",
        "03": "72",
        "04": "85",
        "05": "95",
        "06": "90",
        "07": "80",
      },
      last_week: {
        "01": "55",
        "02": "65",
        "03": "68",
        "04": "75",
        "05": "85",
        "06": "80",
        "07": "70",
      },
    },
    success_rate: "97",
    type: "payout",
  },
  {
    completed_count: 1020,
    diff_periods: "25",
    period: "week",
    periods: {
      current_week: {
        "01": "120",
        "02": "140",
        "03": "150",
        "04": "160",
        "05": "180",
        "06": "170",
        "07": "160",
      },
      last_week: {
        "01": "90",
        "02": "100",
        "03": "110",
        "04": "120",
        "05": "130",
        "06": "125",
        "07": "115",
      },
    },
    success_rate: "99",
    type: "topup",
  },
]

export const yearMock = [
  {
    completed_count: 180,
    diff_periods: "6",
    period: "year",
    periods: {
      "2025": {
        "01": "10",
        "02": "12",
        "03": "14",
        "04": "18",
        "05": "20",
        "06": "22",
        "07": "21",
        "08": "19",
        "09": "17",
        "10": "15",
        "11": "13",
        "12": "11",
      },
      "2026": {
        "01": "14",
      },
    },
    success_rate: "97",
    type: "payout",
  },
  {
    completed_count: 420,
    diff_periods: "18",
    period: "year",
    periods: {
      "2025": {
        "01": "25",
        "02": "30",
        "03": "35",
        "04": "40",
        "05": "55",
        "06": "60",
        "07": "58",
        "08": "54",
        "09": "50",
        "10": "45",
        "11": "38",
        "12": "32",
      },
      "2026": {
        "01": "36",
      },
    },
    success_rate: "100",
    type: "topup",
  },
  {
    completed_count: 310,
    diff_periods: "9",
    period: "year",
    periods: {
      "2025": {
        "01": "20",
        "02": "22",
        "03": "24",
        "04": "26",
        "05": "28",
        "06": "30",
        "07": "29",
        "08": "27",
        "09": "25",
        "10": "23",
        "11": "21",
        "12": "19",
      },
      "2026": {
        "01": "22",
      },
    },
    success_rate: "96",
    type: "on_ramp",
  },
  {
    completed_count: 260,
    diff_periods: "-4",
    period: "year",
    periods: {
      "2025": {
        "01": "18",
        "02": "17",
        "03": "16",
        "04": "15",
        "05": "14",
        "06": "13",
        "07": "14",
        "08": "15",
        "09": "16",
        "10": "17",
        "11": "18",
        "12": "19",
      },
      "2026": {
        "01": "17",
      },
    },
    success_rate: "94",
    type: "off_ramp",
  },
  {
    completed_count: 90,
    diff_periods: "2",
    period: "year",
    periods: {
      "2025": {
        "01": "5",
        "02": "6",
        "03": "7",
        "04": "8",
        "05": "9",
        "06": "10",
        "07": "9",
        "08": "8",
        "09": "7",
        "10": "6",
        "11": "5",
        "12": "4",
      },
      "2026": {
        "01": "6",
      },
    },
    success_rate: "92",
    type: "refund",
  },
  {
    completed_count: 520,
    diff_periods: "14",
    period: "year",
    periods: {
      "2025": {
        "01": "30",
        "02": "35",
        "03": "40",
        "04": "45",
        "05": "50",
        "06": "55",
        "07": "53",
        "08": "51",
        "09": "48",
        "10": "44",
        "11": "38",
        "12": "34",
      },
      "2026": {
        "01": "40",
      },
    },
    success_rate: "99",
    type: "payin",
  },
]

export type StatsPeriod = "day" | "month" | "week" | "year"

type StatsState = {
  data: MerchStatsItemType[]
  period: StatsPeriod
}

export enum MerchantStatsType {
  OFF_RAMP = "off_ramp",
  ON_RAMP = "on_ramp",
  PAYIN = "payin",
  PAYOUT = "payout",
  REFUND = "refund",
  TOPUP = "topup",
}

export type MerchStatsItemType = {
  completed_count: number
  diff_periods: string
  period: StatsPeriod
  periods: Record<string, Record<string, string>>
  success_rate: string
  total: string
  type: MerchantStatsType
}

export type MerchantStatsItemDiffType = "negative" | "neutral" | "positive"

export class MerchantStatistic extends loading(["load"]) {
  state: StatsState = {
    data: [],
    period: "day",
  }

  constructor() {
    super()

    makeObservable(this, {
      changePeriod: action,
      chartData: computed,
      isWeekPeriod: computed,
      period: computed,
      rawData: computed,
      state: observable.deep,
      updateState: action,
    })

    onBecomeObserved(this, "isLoading", this.load)
  }

  changePeriod(period: StatsPeriod) {
    this.updateState({ period })

    return this.load()
  }

  async load() {
    try {
      const {
        data: { data },
      } = await merchantApi.getStats(this.period)

      if (data) {
        // this.updateState({
        //   data: {
        //     day: mockDay,
        //     month: mockMonth,
        //     week: mock,
        //     year: yearMock,
        //   }[this.period] as any,
        // })

        this.updateState({ data: data as StatsState["data"] })
      }
    } catch (e: any) {
      catchErrors(e)
    }
  }

  updateState(s: Partial<StatsState>) {
    this.state = {
      ...this.state,
      ...s,
    }
  }

  get chartData() {
    return buildChartData(this.state)
  }

  get isWeekPeriod() {
    return this.period === "week"
  }

  get period() {
    return this.state.period
  }

  get rawData() {
    return this.state.data
  }
}
